import styled from 'styled-components'

const ReportSummaryValue = styled.div`
  font-size: 28px;
  line-height: 1.25;
  margin: 0;
  font-weight: 600;
`

export default ReportSummaryValue